import React from 'react';
import { Controller } from 'react-hook-form';

import { IToggleProps, Toggle } from '../../components';
import { FormError } from '../FormError';
import { FormField } from '../FormField';
import { FormLabel } from '../FormLabel';

export interface IToggleFieldProps extends IToggleProps {
    name: string;
    label?: string;
}

export const ToggleField = ({ name, label, ...props }: IToggleFieldProps) => {
    return (
        <Controller
            name={name}
            render={({ field: { onChange, value, ...fieldProps }, fieldState: { error } }) => (
                <FormField
                    labelSlot={label && <FormLabel>{label}</FormLabel>}
                    errorSlot={error && <FormError>{error?.message}</FormError>}
                >
                    <Toggle
                        onPressedChange={(value) => {
                            onChange(value);
                        }}
                        pressed={value}
                        {...fieldProps}
                        {...props}
                    />
                </FormField>
            )}
        />
    );
};
